import React, { useEffect } from 'react'
import '../../styles/Payment/PaymentSuccess.css'
import { Fade } from 'react-awesome-reveal'
import { Col, Row } from 'react-bootstrap'
import logo from '../../assets/logo.jpg'
import Confetti from 'react-confetti'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { API_URL } from '../../env'

function PaymentSuccess() {

    const { paymentToken } = useParams()

    useEffect(() => {

        updatePaymentStatus()
    }, [])

    function updatePaymentStatus() {

        axios.put(API_URL + 'payment', {
            paymentToken: paymentToken,
        }).then((response) => {
            console.log("response.data :\n" + JSON.stringify(response.data) + "\n\n")
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    return (

        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <meta name="title" content="Paiement réussi - E5M Diagnostics" />
                <meta name="description" content="Paiement réussi de E5M Diagnostics." />
            </Helmet>

            <BrowserView>
                <div id='paymentSuccess'>
                    <Confetti
                        recycle={false}
                        numberOfPieces={300}
                        run={true}
                        tweenDuration={10000}
                    />
                    <Row>
                        <Col sm={8}>
                            <Fade direction={'down'}>
                                <div id='paymentSuccessLeft'>
                                    <h1 id='paymentSuccessLeftTitle'>
                                        <FontAwesomeIcon icon={faCheckCircle} className='paymentSuccessLeftIcon' />
                                        Paiement réussi
                                        <FontAwesomeIcon icon={faCheckCircle} className='paymentSuccessLeftIcon' />
                                    </h1>
                                    <img src={logo} id='paymentSuccessLeftLogo' alt='logo' />
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={4}>
                            <Fade direction={'up'}>
                                <div id='paymentSuccessRight'>
                                    <div id='paymentSuccessRightTitle'>Vous pouvez fermer cette page</div>
                                    <div id='paymentSuccessRightTitle'>Un email vient de vous etre envoyé contenant les instructions pour télécharger votre diagnostic</div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='paymentSuccess'>
                    <Confetti
                        recycle={false}
                        numberOfPieces={300}
                        run={true}
                        tweenDuration={10000}
                    />
                    <Row>
                        <Col sm={8}>
                            <Fade direction={'down'}>
                                <div id='paymentSuccessLeftMobile'>
                                    <h1 id='paymentSuccessLeftTitleMobile'>
                                        <FontAwesomeIcon icon={faCheckCircle} className='paymentSuccessLeftIconMobile' />
                                        Paiement réussi
                                        <FontAwesomeIcon icon={faCheckCircle} className='paymentSuccessLeftIconMobile' />
                                    </h1>
                                    <img src={logo} id='paymentSuccessLeftLogo' alt='logo' />
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={4}>
                            <Fade direction={'up'}>
                                <div id='paymentSuccessRightMobile'>
                                    <div id='paymentSuccessRightTitleMobile'>Vous pouvez fermer cette page</div>
                                    <div id='paymentSuccessRightTitleMobile'>Un email vient de vous etre envoyé contenant les instructions pour télécharger votre diagnostic</div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </MobileView>
        </>

    )

}

export default PaymentSuccess